import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterListComponent } from './filter-list/filter-list.component';
import { TextFilterComponent } from './text-filter/text-filter.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { InjectComponentDirective } from './inject-component.directive';
import { ListItemComponent } from './list-item/list-item.component';
import { GamerecordListItemComponent } from './gamerecord-list-item/gamerecord-list-item.component';
import { GenericListItemComponent } from './generic-list-item/generic-list-item.component';
import { GenericDialogComponent } from './generic-dialog/generic-dialog.component';
import { MatDialogModule} from '@angular/material/dialog';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import { ComponentHandlerComponent } from './component-handler/component-handler.component';
import { PersonFormComponent } from './person-form/person-form.component';
import { MatRadioModule } from '@angular/material/radio';
import { UserFormComponent } from './user-form/user-form.component';
import { MatSlideToggleModule} from '@angular/material/slide-toggle';
import { GamerecordFormHandlerComponent } from './gamerecord-form-handler/gamerecord-form-handler.component';
import { GamerecordFormBaseComponent } from './gamerecord-form-base/gamerecord-form-base.component';
import { GamerecordFormSpeciesComponent } from './gamerecord-form-species/gamerecord-form-species.component';
import { GamerecordFormErlegerComponent } from './gamerecord-form-erleger/gamerecord-form-erleger.component'; 
import {MatDatepickerModule} from '@angular/material/datepicker'
import { MatSelectModule } from '@angular/material/select';
import { MyBtnSpeciesComponent } from './my-btn-species/my-btn-species.component';
import { MyBtnGenericComponent } from './my-btn-generic/my-btn-generic.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ComponentSettingsHandlerComponent } from './component-settings-handler/component-settings-handler.component';
import { NavListItemComponent } from './nav-list-item/nav-list-item.component';
import { SettingFormBaseComponent } from './setting-form-base/setting-form-base.component';
import { HuntingEventFormComponent } from './hunting-event-form/hunting-event-form.component';
import { UtilizationOptionFormComponent } from './utilization-option-form/utilization-option-form.component';
import { GamerecordFormUtilizationComponent } from './gamerecord-form-utilization/gamerecord-form-utilization.component';
import { SettingSpeciesFormComponent } from './setting-species-form/setting-species-form.component';
import {MatChipsModule} from '@angular/material/chips';
import { LabSampleFormComponent } from './lab-sample-form/lab-sample-form.component';
import { HuntingDistrictFormComponent } from './hunting-district-form/hunting-district-form.component';
import { GameCollectStationFormComponent } from './game-collect-station-form/game-collect-station-form.component';
import { PoiListItemComponent } from './poi-list-item/poi-list-item.component';
import { PoiFormComponent } from './poi-form/poi-form.component';
import { TrophyFormComponent } from './trophy-form/trophy-form.component';
import { SettingGeoObjectTypeFormComponent } from './setting-geo-object-type-form/setting-geo-object-type-form.component';
import { MapInfoDisplayComponent } from './map-info-display/map-info-display.component'; 
import { MAPBOX_API_KEY, NgxMapboxGLModule } from 'ngx-mapbox-gl';
import { IMyLibMapModuleConfig } from '../cockpit/objects/objects.module';
import { ModuleWithProviders } from '@angular/core';
import { DonutChartComponent } from './donut-chart/donut-chart.component';
import { EventIvitationTableComponent } from './event-ivitation-table/event-ivitation-table.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { LocationPickerComponent } from './location-picker/location-picker.component';
import { PoiFormHandlerComponent } from './poi-form-handler/poi-form-handler.component';
import { PersonEventOverviewTableComponent } from './person-event-overview-table/person-event-overview-table.component';
import { TransactionLogComponent } from './transaction-log/transaction-log.component';
import { ChartsDoughnutComponent } from './charts-doughnut/charts-doughnut.component';
import { SettingSiteReferralComponent } from './setting-site-referral/setting-site-referral.component';
import { IconPickerComponent } from './icon-picker/icon-picker.component';
import { SignaturePadDialogComponent } from './signature-pad-dialog/signature-pad-dialog.component';
import { GeoObjectLineTypesSettingFormComponent } from './geo-object-line-types-setting-form/geo-object-line-types-setting-form.component';
import { GeoObjectPolygonTypesSettingFormComponent } from './geo-object-polygon-types-setting-form/geo-object-polygon-types-setting-form.component';
import { GamerecordListItemDisabledComponent } from './gamerecord-list-item-disabled/gamerecord-list-item-disabled.component';
import { GameOriginFormDialogComponent } from './game-origin-form-dialog/game-origin-form-dialog.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { InviteUserFormComponent } from './invite-user-form/invite-user-form.component';
import { GeoObjectCategoryFormComponent } from './geo-object-category-form/geo-object-category-form.component';
import { GenericListItemDisabledComponent } from './generic-list-item-disabled/generic-list-item-disabled.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { GameRecordWebtsnDialogComponent } from './game-record-webtsn-dialog/game-record-webtsn-dialog.component';
import { EditPoiPointComponent } from '../cockpit/objects/edit-poi-point/edit-poi-point.component';
import { HuntingDistrictListDialogComponent } from './hunting-district-list-dialog/hunting-district-list-dialog.component';
import { MatListModule } from '@angular/material/list';
import { GamerecordFormLabSamplesComponent } from './gamerecord-form-lab-samples/gamerecord-form-lab-samples.component';
import { NgxColorsModule } from 'ngx-colors';
import { UserRolesFormComponent } from './user-roles-form/user-roles-form.component';
import { UserRolesDataAccessDialogComponent } from './user-roles-data-access-dialog/user-roles-data-access-dialog.component';
import { ContextRightsPickerComponent } from './context-rights-picker/context-rights-picker.component';
import { UserSettingsDialogComponent } from './user-settings-dialog/user-settings-dialog.component';
import { DatePresetFilterComponent } from './date-preset-filter/date-preset-filter.component';
import { GenericGridListComponent } from './generic-grid-list/generic-grid-list.component';
import { UserMultiEditDialogComponent } from './user-multi-edit-dialog/user-multi-edit-dialog.component';
import { FormDialogComponent } from './form-dialog/form-dialog.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AgGridModule } from 'ag-grid-angular';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SuperContextSettingsDialogComponent } from './super-context-settings-dialog/super-context-settings-dialog.component';

ModuleRegistry.registerModules([AllCommunityModule]);
ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-127558}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{diwima_GmbH}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{diwima}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{diwima}_need_to_be_licensed___{diwima}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{28_April_2027}____[v3]_[01]_MTgwODg2NjgwMDAwMA==c6941540e265a9566d2ebd3022601197',
);

@NgModule({
  declarations: [
    FilterListComponent,
    TextFilterComponent,
    InjectComponentDirective, 
    ListItemComponent,
    GamerecordListItemComponent,
    GenericListItemComponent,
    GenericDialogComponent,
    ComponentHandlerComponent,
    PersonFormComponent,
    UserFormComponent,
    GamerecordFormHandlerComponent,
    GamerecordFormBaseComponent,
    GamerecordFormLabSamplesComponent,
    GameRecordWebtsnDialogComponent,
    GamerecordFormSpeciesComponent,
    GamerecordFormErlegerComponent,
    MyBtnSpeciesComponent,
    MyBtnGenericComponent,
    ComponentSettingsHandlerComponent,
    NavListItemComponent,
    SettingFormBaseComponent,
    HuntingEventFormComponent,
    UtilizationOptionFormComponent,
    GamerecordFormUtilizationComponent,
    SettingSpeciesFormComponent,
    LabSampleFormComponent,
    HuntingDistrictFormComponent,
    HuntingDistrictListDialogComponent,
    GameCollectStationFormComponent,
    PoiListItemComponent,
    PoiFormComponent,
    EditPoiPointComponent,
    TrophyFormComponent,
    SettingGeoObjectTypeFormComponent,
    MapInfoDisplayComponent,
    DonutChartComponent,
    EventIvitationTableComponent,
    LocationPickerComponent,
    PoiFormHandlerComponent,
    PersonEventOverviewTableComponent,
    TransactionLogComponent,
    ChartsDoughnutComponent,
    SettingSiteReferralComponent,
    IconPickerComponent,
    SignaturePadDialogComponent,
    GeoObjectLineTypesSettingFormComponent,
    GeoObjectPolygonTypesSettingFormComponent,
    GamerecordListItemDisabledComponent,
    GameOriginFormDialogComponent,
    InviteUserFormComponent,
    GeoObjectCategoryFormComponent,
    GenericListItemDisabledComponent,
    UserRolesFormComponent,
    UserRolesDataAccessDialogComponent,
    UserSettingsDialogComponent,
    SuperContextSettingsDialogComponent,
    DatePresetFilterComponent,
    GenericGridListComponent,
    UserMultiEditDialogComponent,
    FormDialogComponent
	],
	imports: [
    CommonModule,
    AgGridModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCheckboxModule,
    MatButtonModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    MatRippleModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCardModule,
    MatTooltipModule,
    MatChipsModule,
    MatTableModule,
    MatMenuModule,
    MatSortModule,
    MatPaginatorModule,
    TranslateModule.forChild(),
    FormsModule,
    NgxMapboxGLModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    MatListModule,
    NgxColorsModule,
    ContextRightsPickerComponent,
    MatExpansionModule
  ],
  exports: [
    FilterListComponent, 
    InjectComponentDirective, 
    ComponentHandlerComponent,
    ComponentSettingsHandlerComponent,
    DonutChartComponent,
    TextFilterComponent,
    EventIvitationTableComponent,
    PersonEventOverviewTableComponent,
    TransactionLogComponent,
    ChartsDoughnutComponent,
    ListItemComponent,
    
    DatePresetFilterComponent,
    GenericGridListComponent

    // MapInfoDisplayComponent
  ],
  providers: [MatNativeDateModule]

})
export class SharedModule {
  static forRoot(config: IMyLibMapModuleConfig): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        {
          provide: MAPBOX_API_KEY,
          useValue: config.mapboxToken,
        },
      ],
    };
  }
}
